import React from 'react';
import '../shared/ordersShimmer.css';
import './MyOrdersSkeleton.css';

const Shimmer: React.FC<{ className: string }> = ({ className }) => (
  <div className={`orders-shimmer ${className}`} aria-hidden />
);

const OrderCardSkeleton: React.FC = () => (
  <div className="mo-sk-card">
    <div className="mo-sk-card-head">
      <div className="mo-sk-card-main">
        <div className="mo-sk-status-row">
          <Shimmer className="mo-sk-pill" />
          <Shimmer className="mo-sk-pill mo-sk-pill--sm" />
        </div>
        <Shimmer className="mo-sk-line mo-sk-line--title" />
        <Shimmer className="mo-sk-line mo-sk-line--meta" />
        <Shimmer className="mo-sk-line mo-sk-line--date" />
      </div>
      <Shimmer className="mo-sk-total" />
    </div>
    <div className="mo-sk-card-foot">
      <Shimmer className="mo-sk-foot-total" />
      <Shimmer className="mo-sk-foot-btn" />
    </div>
  </div>
);

interface MyOrdersSkeletonProps {
  cardCount?: number;
}

const MyOrdersSkeleton: React.FC<MyOrdersSkeletonProps> = ({ cardCount = 3 }) => (
  <div className="my-orders-skeleton" aria-busy="true" aria-label="Loading your orders">
    <div className="orders-content-wrapper">
      <div className="orders-tabs mo-sk-tabs">
        <Shimmer className="mo-sk-tab mo-sk-tab--active" />
        <Shimmer className="mo-sk-tab" />
      </div>
      <div className="orders-body mo-sk-body">
        <div className="orders-list">
          {Array.from({ length: cardCount }, (_, i) => (
            <OrderCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default MyOrdersSkeleton;
